export default "__VITE_ASSET__CJjiXaFX__"